// The remix someone asked for before paying for it, kept across the trip to Stripe.
//
// A free account has no AI video (2026-10-27), and a remix is one. Pressing "Remix with Pro" opens
// the Remix offer (components/Remix/RemixOffer.jsx), which promises that the remix starts by itself
// once they have paid: the request goes into this browser before checkout, and PendingRemix.jsx
// makes it when they are back with a video to spend. `paid` is set by whoever sees the payment: the
// pack's confirm (growth/CheckoutComeback.jsx) or the subscription's success page. A checkout left at
// Stripe starts nothing; the dialog opens on the same choices the next time (`readPendingRemix`).
// The same shape as utils/pendingVideo.js, under its own key, so a first video and a remix kept at
// once never take each other's place.
const KEY = 'pending_remix';
// A checkout takes minutes; a kept remix older than this belongs to another visit
const FRESH_MS = 2 * 60 * 60 * 1000;
export const REMIX_PAID_EVENT = 'pending-remix-paid';

/** `request` is the body of POST /ai-agent/remix; `returnTo` the page the dialog was opened on. */
export function keepPendingRemix(request, returnTo, now = Date.now()) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ request, returnTo, at: now, paid: false }));
  } catch {
    // A private window: after paying they press Remix again, and it is made at once
  }
}

/** The kept remix if it is fresh: {request, returnTo, at, paid}, else null. */
export function readPendingRemix(now = Date.now()) {
  try {
    const kept = JSON.parse(window.localStorage.getItem(KEY) || 'null');
    if (!kept?.request?.short_id || !kept.at || now - kept.at > FRESH_MS) return null;
    return kept;
  } catch {
    return null;
  }
}

export function markPendingRemixPaid() {
  const kept = readPendingRemix();
  if (!kept) return false;
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ ...kept, paid: true }));
    window.dispatchEvent(new Event(REMIX_PAID_EVENT));
  } catch {
    return false;
  }
  return true;
}

export function clearPendingRemix() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // nothing kept
  }
}
